import apiClient from './ApiService'

export default {
  getAllOrganizaciones() {
    return apiClient.get('/organizaciones/all')
  },
  
  getOrganizaciones(page = 1, limit = 15, filters = {}) {
    return apiClient.get('/organizaciones', {
      params: {
        page,
        limit,
        ...filters
      }
    })
  },
  
  getOrganizacion(id) {
    return apiClient.get(`/organizaciones/${id}`)
  },
  
  createOrganizacion(organizacion) {
    return apiClient.post('/organizaciones', organizacion)
  },
  
  updateOrganizacion(id, organizacion) {
    return apiClient.put(`/organizaciones/${id}`, organizacion)
  },
  
  deleteOrganizacion(id) {
    return apiClient.delete(`/organizaciones/${id}`)
  },
  
  exportarListado(formato, filtros = {}) {
    return apiClient.get('/organizaciones/exportar', {
      params: {
        formato,
        ...filtros
      },
      responseType: 'blob'
    })
  }
}